<template>
  <div>
    <div class="preview-border" style="border-radius: 4px 4px 0px 0px; margin-top: 8px;">
      <p class="preview-title m-0">{{isAcryl?"プレートプレビュー":"シートプレビュー"}}</p>
    </div>
    <div class="preview-border d-flex flex-column" style="border-radius: 0px 0px 4px 4px;">
      <div v-if="showModeSwitch">
        <div class="col d-flex justify-content-between my-2" style="margin-left: 35px; margin-right: 20px;">
          <input class="me-2 radio-btn" type="radio" id="option1" value="0" v-model="previewMode" />
          <label class="d-block" for="option1">3Dプレビュー</label>
        </div>
        <div class="col d-flex justify-content-between my-2" style="margin-left: 35px; margin-right: 20px;">
          <input class="me-2 radio-btn" type="radio" id="option3" value="2" v-model="previewMode" />
          <label for="option3">2Dプレビュー</label>
        </div>
      </div>
      <hr v-if="showModeSwitch" class="my-0">
      <div class="row m-0">
        <div class="col pl-3 mb-1 pt-1">
          <div class="fw-bold text-start" style="margin-left: 47px; font-size: 13px;">背景</div>
          <div class="d-flex justify-content-center pt-1">
          <div
            class="color_box"
            v-for="(color, index) in this.getColorList"
            v-bind:key="index"
            :style="getBackgroundBoxStyle(index)"
            @click="clickBackgroundBox(index)"
          />
          </div>
        </div>
      </div>
      <div class="status-error-color text-start m-2" style="font-size: 13px;">
        ※ 確認用のため仕上がりには影響しません。
      </div>
    </div>
  </div>
</template>

<script>
import { PreviewColorList } from "@/js/Const.js";


export default {
  name: "PreviewMode",
  props: {
    showModeSwitch: {
      type: Boolean,
      default: true,
    },
    isAcryl: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      previewMode: "0",
    };
  },
  watch: {
    "previewMode": function(){
      this.$store.commit('designPreview/set', { key: 'is3DPreviewMode', value: this.previewMode == 0 })
    },
  },
  created() {
  },
  methods: {
    clickBackgroundBox(index) {
      this.$store.commit('designPreview/set', { key: 'selectBackgroundColor', value: index })
    },
  },
  computed: {
    getColorList() {
      return PreviewColorList;
    },
    getBackgroundBoxStyle() {
      return function (index) {
        return {
          border:
            this.$store.state.designPreview.selectBackgroundColor == index ? "solid 2px" : "solid 1px",
          "border-color":
            this.$store.state.designPreview.selectBackgroundColor == index ? "#000000" : "#999999",
          "background-color": PreviewColorList[index],
        };
      };
    },
  }
};
</script>

<style scoped lang="scss">
.preview-border{
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
}
.preview-title{
  color: $text-white-color;
  background-color: $primary-main-color;
}
.radio-btn{
  height: 25px;
  width: 25px;
  accent-color: #8593bc;
}
.color_box {
  height: 25px;
  width: 25px;
  margin: 2px;
  border-radius: 5px;
}
</style>
